import {styled} from '@mui/material/styles';
import { Grid } from '@mui/material';

export const LateralPanelContainer = styled(Grid)`
    height: fit-content;
    @media screen and (min-width: 960px){
        margin: 16px;
    }
`